import { Box } from '@mui/material';
import EmptyStateIcon, {
  EmptyStateWrapper,
  NO_DATA_FOR_PERIOD_MESSAGE,
} from 'components/_common/EmptyState';
import { formatSecToHourString, notUndefiend, valueAsString } from 'helpers/conversions';
import React from 'react';
import { likeIcon } from '../Icons';
import { Spinner } from '../Styles';
import { ReactComponent as ArrowUpIcon } from '../../../assets/icons/TopCardsArrowUp.svg';
import { ReactComponent as ArrowDownIcon } from '../../../assets/icons/TopCardsArrowDown.svg';
import { StatsData } from '../Card';
import { TimeFrameEnum } from 'models/ReportData';
import {
  OverviewTopCardNames,
  getDescriptionTextForCustomTimeframe,
  getTopCardArrowColor,
} from 'helpers/overviewUtils';
import { styles } from './DesktopAverageAvailabilityCard.styles';
import { styles as topCardStyles } from './DesktopTotalImpressionCard.styles';

const DesktopAverageAvailabilityCardApollo = props => {
  const {
    stats,
    description,
    value,
    units,
    statsDescription,
    addedData,
    timeframe,
    customTimeframeProperties,
  } = props;
  const [isNegative, setIsNegative] = React.useState(false);
  React.useEffect(() => {
    if (notUndefiend([stats])) {
      if (stats! < 0) {
        setIsNegative(true);
      } else if (description === 'Average Availability' && value >= 0.999) {
        setIsNegative(false);
      } else {
        setIsNegative(false);
      }
    }
  }, [stats]); // eslint-disable-line react-hooks/exhaustive-deps
  const getArrowIcon = (addedData, row) => {
    const trend = addedData[row].trend;
    const description = addedData[row].description;
    if (trend === 0 || trend === undefined) {
      return <></>;
    }
    return trend > 0 ? (
      <ArrowUpIcon
        fill={getTopCardArrowColor({
          cardName: OverviewTopCardNames.averageAvailability,
          trend,
          description,
        })}
      />
    ) : (
      <ArrowDownIcon
        fill={getTopCardArrowColor({
          cardName: OverviewTopCardNames.averageAvailability,
          trend,
          description,
        })}
      />
    );
  };
  if (value === null) {
    return (
      <EmptyStateWrapper>
        <EmptyStateIcon icon="no-icon" message={NO_DATA_FOR_PERIOD_MESSAGE} />
      </EmptyStateWrapper>
    );
  }

  return notUndefiend([value]) ? (
    <Box
      display="flex"
      justifyContent="space-between"
      width="100%"
      height="100%"
      boxSizing="border-box"
      sx={styles.innerCardContent}
      data-testid="average-availability-card">
      <Box display="flex" boxSizing="border-box" height="100%" width="57%">
        <Box
          display="flex"
          flexDirection="column"
          boxSizing="border-box"
          width="100%"
          height="100%">
          <Box
            display="flex"
            flexDirection="column"
            boxSizing="border-box"
            width="100%"
            height="80px"
            sx={styles.upperRow}>
            <Box display="flex" alignItems="flex-start">
              <div>{isNegative ? likeIcon.negative : likeIcon.positive}</div>
              <Box sx={topCardStyles.value} data-testid="avg-availability-value">
                {value === -1 ? '--' : valueAsString(value, true)}
              </Box>
              <Box sx={topCardStyles.units} data-testid="avg-availability-units">
                {value === -1 ? '' : units}
              </Box>
            </Box>

            <Box sx={topCardStyles.description} data-testid="avg-availability-description">
              {description}
            </Box>
          </Box>
          <Box
            display="flex"
            alignItems="flex-end"
            width="100%"
            height="100%"
            boxSizing="border-box"
            sx={topCardStyles.bottomRow}>
            {notUndefiend([stats]) && StatsData(stats!)}
            <div>
              {timeframe === TimeFrameEnum.custom
                ? getDescriptionTextForCustomTimeframe({ timeframe, customTimeframeProperties })
                : statsDescription}
            </div>
          </Box>
        </Box>
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        boxSizing="border-box"
        height="100%"
        width="40%"
        sx={styles.rightColumn}>
        <Box
          display="flex"
          alignItems="center"
          boxSizing="border-box"
          width="100%"
          height="50px"
          sx={styles.rightColumnUpperRow}>
          <Box display="flex" width="20px" alignSelf="center">
            {getArrowIcon(addedData, 'upper')}
          </Box>
          <Box display="flex" flexDirection="column" sx={styles.rightColumnContent}>
            <Box display="flex" sx={styles.rightColumnContentUpperRow}>
              {formatSecToHourString(addedData?.upper?.value)} {addedData.upper.unit}
            </Box>
            <Box sx={styles.rightColumnContentBottomRow}>{addedData.upper.description}</Box>
          </Box>
        </Box>
        <Box display="flex" boxSizing="border-box" width="100%" sx={styles.rightColumnBottomRow}>
          <Box display="flex" width="20px" alignSelf="center">
            {getArrowIcon(addedData, 'lower')}
          </Box>
          <Box display="flex" flexDirection="column" sx={styles.rightColumnContent}>
            <Box display="flex" sx={styles.rightColumnContentUpperRow}>
              {formatSecToHourString(addedData?.lower?.value)} {addedData.lower.unit}
            </Box>
            <Box sx={styles.rightColumnContentBottomRow}>{addedData.lower.description}</Box>
          </Box>
        </Box>
      </Box>
    </Box>
  ) : (
    Spinner(60)
  );
};
export default DesktopAverageAvailabilityCardApollo;
